import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-itams.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { MapService } from "../../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { AlertType } from "../../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationLocationItamsConstants } from "./create-application-location-itams.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { debounceTime } from "rxjs";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
let CreateApplicationLocationItamsComponent = class CreateApplicationLocationItamsComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientListService;
    appController;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    active;
    baysForm;
    descriptionLabel1 = CreateApplicationLocationItamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationItamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationItamsConstants.DESCRIPTION_LABEL_3;
    detailsFormControlName = CreateApplicationLocationItamsConstants.DETAILS_FORM_CONTROL_NAME;
    baysFormGroupName = CreateApplicationLocationItamsConstants.BAYS_FORM_GROUP_NAME;
    validationMessages = CreateApplicationLocationItamsConstants.VALIDATION_MESSAGES;
    addressControl = CreateApplicationLocationItamsConstants.ADDRESS_CONTROL;
    bayNumberControl = CreateApplicationLocationItamsConstants.BAY_NUMBER_CONTROL;
    baySizeControl = CreateApplicationLocationItamsConstants.BAY_SIZE_CONTROL;
    previousApplicationValidatedFormControlName = CreateApplicationLocationItamsConstants.PREVIOUS_APPLICATION_VALIDATED_FORM_CONTROL_NAME;
    addressTextPlaceHolder = CreateApplicationLocationItamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    bayNumberPlaceHolder = CreateApplicationLocationItamsConstants.BAY_NUMBER_PLACEHOLDER;
    baySizeTextPlaceHolder = CreateApplicationLocationItamsConstants.BAY_SIZE_TEXT_PLACEHOLDER;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeBayLabel = CreateApplicationLocationItamsConstants.REMOVE_BAY_LABEL;
    mapComponent;
    isMapLoaded = false;
    showAddBayButton = true;
    selectedBaySubjectSubscription;
    removeShowBaySubjectSubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, recipientListService, appController, mapService, requestStatusService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.setupSubscribers();
        if (this.createApplicationService.propertyData) {
            this.loadExistingBays(this.createApplicationService.propertyData);
            this.createApplicationService.propertyData = null;
        }
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        const enableAddBaysButton = this.aflaModuleStrategyService.form.get(this.detailsFormControlName).get(this.previousApplicationValidatedFormControlName).value;
        try {
            if (enableAddBaysButton) {
                this.mapService.actionBayEnabled = false;
            }
            else {
                this.mapService.actionBayEnabled = true;
            }
        }
        catch (e) {
            this.mapService.actionBayEnabled = true;
        }
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionBayEnabled = false;
    }
    loadMetadata() {
    }
    getBays() {
        return this.baysForm.get("bays");
    }
    onBtnRemoveBayClicked(bayIndex) {
        const previoursActiveIndex = this.active;
        this.getBays().removeAt(bayIndex);
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
        if (previoursActiveIndex === bayIndex && bayIndex > 0) {
            this.active = bayIndex - 1;
        }
        else if (previoursActiveIndex > bayIndex) {
            this.active - bayIndex - 1;
        }
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    setNumberToDecimal(control, event) {
        // sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    initForm() {
        this.baysForm = this.aflaModuleStrategyService.form.get(this.baysFormGroupName);
    }
    loadExistingBays(bayObject) {
        this.setBayData(bayObject, bayObject.geometry);
    }
    setBayData(bayObject, geometry) {
        this.requestStatusService.showBusySpinner("GetBayData");
        const objectId = this.propertyDataAlternateColumnName(bayObject, "OBJECTID", "objectid");
        let found = false;
        this.getBays().controls.forEach(item => {
            const check = item.get("objectId").value;
            if (check === objectId) {
                found = true;
                this.appController.showMessage(CreateApplicationLocationItamsConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetBayData");
            }
        });
        if (!found) {
            const newBay = new FormGroup({
                objectId: new FormControl(this.propertyDataAlternateColumnName(bayObject, "OBJECTID", "objectid")),
                address: new FormControl(this.bayDataAlternateColumnName(bayObject, "Address", "address"), [Validators.required]),
                geometry: new FormControl(geometry),
                bayNumber: new FormControl(this.bayDataAlternateColumnName(bayObject, "BayNumber", "baynumber"), [Validators.required]),
                baySize: new FormControl(this.bayDataAlternateColumnName(bayObject, "Size", "size"), [Validators.required]),
                centroid: new FormControl(null, [Validators.required])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData).subscribe({
                next: (trueCentroidResponse) => {
                    newBay.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    this.setBayTrueCentroidData(newBay, trueCentroidResponse);
                    this.syncMapGeometries();
                    this.requestStatusService.removeBusySpinner("GetBayData");
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage("centroid", error, CRUDOperation.Get);
                    this.requestStatusService.removeBusySpinner("GetBayData");
                }
            });
        }
    }
    setBayTrueCentroidData(newFormGroup, trueCentroidResponse) {
        const bayControl = this.getBays();
        newFormGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
        bayControl.push(newFormGroup);
        this.active = bayControl.length - 1;
        this.changeDetectorRefs.detectChanges();
    }
    bayDataAlternateColumnName(bayObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(bayObject)) {
            if (key === name1) {
                returnVal = bayObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = bayObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = bayObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getBays().controls.forEach(bayControl => {
            const geom = bayControl.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "ITAMS graphics", true);
        }
    }
    subscribeToBay() {
        this.selectedBaySubjectSubscription = this.mapService.$selectedBaySubject.pipe(debounceTime(1000)).subscribe(bay => {
            if (bay !== null) {
                this.setBayData(bay.attributes, bay.geometry);
            }
        });
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    setupSubscribers() {
        this.subscribeToBay();
        this.subscribeToRemoveAddBayButton();
    }
    subscribeToRemoveAddBayButton() {
        this.removeShowBaySubjectSubscription = this.createApplicationService.$removeShowBaySubject.subscribe({
            next: (removeAddBayButton) => {
                if (removeAddBayButton) {
                    this.showAddBayButton = false;
                }
                else {
                    this.showAddBayButton = true;
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientListService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationItamsComponent = __decorate([
    Component({
        selector: "app-create-application-location-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateApplicationLocationItamsComponent);
export { CreateApplicationLocationItamsComponent };
